import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 19.48 21.79"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M19.37 5.58c0-1.26-.6-2.4-1.87-2.88L11.96.48a5.55 5.55 0 0 0-4.55 0L1.86 2.7s-.07.03-.1.05C.78 3.31 0 4.33 0 5.59v4.45c0 5.4 4.06 10.53 9.56 11.72.12.03.24.03.35 0 5.5-1.2 9.56-6.32 9.56-11.72v-.22l-.11-4.24Zm-1.56 4.25v.21c0 4.56-3.42 8.95-8.07 10.05-4.65-1.1-8.07-5.49-8.07-10.05V5.59c0-.51.32-1.03.87-1.36l5.51-2.2s.02 0 .04-.02c1-.46 2.2-.46 3.2 0 .01 0 .02.01.04.02l5.56 2.23h.02c.26.1.45.26.58.47s.21.5.21.87l.11 4.24Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M11.3 6.78c-.59 0-1.1.15-1.56.44-.46-.3-.97-.44-1.56-.44-1.86 0-3.12 1.67-3.12 3.23 0 1.22.68 2.49 1.92 3.58.57.5 1.1.82 1.45 1 .23.13.46.22.66.29.25.09.46.13.65.13s.39-.04.64-.12c.2-.07.42-.16.65-.28.35-.18.89-.49 1.46-.98 1.24-1.07 1.93-2.35 1.93-3.62 0-1.56-1.25-3.23-3.12-3.23m-1.55 6.68s-.06-.01-.14-.04c-.12-.04-.27-.11-.44-.2-.39-.21-.8-.49-1.16-.8-.52-.45-1.39-1.37-1.39-2.4 0-.68.56-1.67 1.56-1.67.47 0 .74.17 1.01.44.3.3.8.3 1.1 0 .27-.27.53-.44 1.01-.44.89 0 1.56.88 1.56 1.67 0 1.09-.87 2-1.38 2.44-.35.3-.76.58-1.15.78-.17.08-.32.15-.44.19-.08.03-.13.04-.13.04Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }